import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { version } from '../../../package.json';

const service = 'app-v4-client';

const {
  cventEnv: env,
  dataDogRumAppId,
  dataDogRumClientToken,
} = window.globals;

export function initDataDog(params) {
  const { origin } = window.location;
  const { showId, eventId, teamId } = params;

  if (env && env !== 'local') {
    datadogRum.init({
      applicationId: dataDogRumAppId,
      clientToken: dataDogRumClientToken,
      service,
      env,
      version,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 30,
      trackSessionAcrossSubdomains: true,
      useSecureSessionCookie: true,
      useCrossSiteSessionCookie: true,
      traceSampleRate: 20,
      allowedTracingUrls: [origin, `${origin}/api`], // Dynamically get API URL since sg50, ld50 and pr50 have different URLs
    });

    datadogLogs.init({
      env,
      service,
      version,
      sessionSampleRate: 100,
      forwardConsoleLogs: ['error'], // error, info e.t.c
      clientToken: dataDogRumClientToken,
      forwardErrorsToLogs: true, // If true this will forward console.error logs, uncaught exceptions and network errors to Datadog.
      trackSessionAcrossSubdomains: true,
      useSecureSessionCookie: true,
      useCrossSiteSessionCookie: true,
    });

    /**
     * Forwarded console.error logs, uncaught exceptions and network errors,
     * will not have these tags set by default,
     * adding them globally to all logs and RUM sessions
     */
    const idMap = {
      'studio.team.id': teamId,
      'studio.show.id': showId,
      'studio.event.id': eventId,
    };

    Object.entries(idMap).forEach(([key, value]) => {
      datadogRum.setGlobalContextProperty(key, value);
      datadogLogs.setGlobalContextProperty(key, value);
    });
  } else {
    console.info(
      `Skipped initializing datadog monitoring for this environment: ${env}`,
    );
  }
}

export function addDataDogUserContext(user) {
  if (env && env !== 'local') {
    const userId = user && user._id;
    const contextKey = 'studio.user.id';
    datadogRum.setGlobalContextProperty(contextKey, userId);
    datadogLogs.setGlobalContextProperty(contextKey, userId);
  }
}

export default {
  initDataDog,
  addDataDogUserContext,
};
